<span [ngClass]="{'_load-animate _load-active': ui.loading}">
    <div class="_dialog-title">
        <mat-icon svgIcon="logo" class="mr-2"></mat-icon>
        <span>{{title | translate}}</span>
    </div>

    <div class="_dialog-content">
        <mat-tab-group class="wiz-tabs hide-headers" [(selectedIndex)]="step">
            <!--LOGIN START-->
            <mat-tab>
                <form #signInForm="ngForm" [formGroup]="signFormGroup" *ngIf="step == stepsMap.sign">
                    <p>{{'_LOYALTY.sign_other' | translate}}</p>
                    <mat-form-field color="accent" appearance="outline" class="with-pad">
                        <mat-label>{{'mobile' | translate}}</mat-label>
                        <oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
                                                [onlyCountries]="appService.regionArgs.phoneOnlyCountries"
                                                [enablePlaceholder]="true"
                                                [enableSearch]="true"
                                                [searchPlaceholder]="appService.translate('search')"
                                                format="national"
                                                name="phone"
                                                formControlName="phone"
                                                required
                                                #phone></oao-mat-intl-tel-input>
                        <!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
                        <!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
                        <mat-error *ngIf="signInForm.form.controls['phone']?.errors?.validatePhoneNumber">{{'invalid_phone' | translate}}</mat-error>
                    </mat-form-field>
                    <!--<div class="mb-3" *ngIf="appService.cachedPaymentInfo">
                        <mat-checkbox name="savePaymentInfo" formControlName="savePaymentInfo">
                            {{'MESSAGES.SAVE_INFO_PAYMENT' | translate}}
                        </mat-checkbox>
                    </div>-->

					@if (ui.licenseCaption) {
						<div class=" text-center text-xs mb-4 mt-2">
							<div>{{ui.licenseCaption | translate}}</div>
							<div class="flex a-center j-center">
								<a class="inline link mr-2" (click)="appService.showContractDialog('contract')">{{'READ_AND_APPROVE_CONTRACT_C' | translate}}</a>
								<a class="inline link" (click)="appService.showContractDialog('privacy')">{{'READ_AND_APPROVE_CONTRACT_D' | translate}}</a>
							</div>
						</div>
					}

                    <div class="_bottom-actions">
                        <button type="button" mat-button class="_cancel" (mousedown)="cancel()">{{'Cancel' | translate}}</button>
                        <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="signIn()">{{'sign_in_action' | translate}}</button>
                    </div>

                </form>
            </mat-tab>
            <!--LOGIN END-->
            <!--REGISTER START-->
            <mat-tab>
                <form (ngSubmit)="signUp(signUpForm)" #signUpForm="ngForm">

                    <p>{{'sign_up_message' | translate}}</p>

                    <mat-form-field color="accent" appearance="outline">
                        <mat-label>{{'first_name' | translate}}</mat-label>
                        <input matInput #FN="ngModel" type="text" [(ngModel)]="formModel.FirstName" name="FirstName" validName required>
                        <mat-icon matSuffix (click)="formModel.FirstName = null" *ngIf="formModel.FirstName">close</mat-icon>
                        <mat-error *ngIf="FN.dirty && FN.errors?.nameField">{{FN.errors.nameField | translate}}</mat-error>
                    </mat-form-field>

                    <mat-form-field color="accent" appearance="outline">
                        <mat-label>{{'last_name' | translate}}</mat-label>
                        <input matInput #LN="ngModel" type="text" [(ngModel)]="formModel.LastName" name="LastName" validName required>
                        <mat-icon matSuffix (click)="formModel.LastName = null" *ngIf="formModel.LastName">close</mat-icon>
                        <mat-error *ngIf="LN.dirty && LN.errors?.nameField">{{LN.errors.nameField | translate}}</mat-error>
                    </mat-form-field>

                    <mat-form-field color="accent" appearance="outline">
                        <mat-label>{{'email' | translate}}</mat-label>
                        <input matInput [placeholder]="'email' | translate" [(ngModel)]="formModel.Email" name="email" type="email" email required class="ltr-field">
                        <mat-icon matSuffix (click)="formModel.email = null" *ngIf="formModel.email">close</mat-icon>
                    </mat-form-field>

                    <div class="mt-3" *ngIf="appService.cachedPaymentInfo">
                        <mat-checkbox name="savePaymentInfo" [(ngModel)]="savePaymentInfo">
                            {{'MESSAGES.SAVE_INFO_PAYMENT' | translate}}
                        </mat-checkbox>
                    </div>

                    <div class="_bottom-actions">
                        <button type="button" mat-button class="_cancel" (click)="cancel()">{{'Cancel' | translate}}</button>
                        <button type="submit" mat-flat-button color="accent" class="rounded">{{'sign_up_action' | translate}}</button>
                    </div>

                </form>
            </mat-tab>
            <!--REGISTER END-->
            <!--CHALLENGE START-->
            <mat-tab>
                <form (ngSubmit)="confirmPhone(challengeForm)" #challengeForm="ngForm" class="">

                    <p>
                        {{'enter_code_message' | translate}}
                        <span style="display:block" class="ltr-field">{{formModel.phone | phone}}</span>
                    </p>

                    <mat-form-field color="accent" appearance="outline">
                        <mat-label>{{'verification_code' | translate}}</mat-label>
                        <input matInput type="tel" [(ngModel)]="formModel.code" name="code" required minlength=4 maxlength=4>
                        <mat-icon matSuffix (click)="formModel.code = null" *ngIf="formModel.code">close</mat-icon>
                    </mat-form-field>


                    <div class="text-far" style="position:relative; top: -8px; margin-bottom: 15px;">
                        <button type="button" mat-button (click)="resendPinCode()">
                            {{'resend' | translate}}
                        </button>
                    </div>

					@if (enableAnonymousLogin) {
						<div class="text-center" style="position:relative; margin-bottom: 15px; top: -10px">
						  <button type="button" class="btn btn-outline-primary" (click)="loginAnonymous()">
                              <span style="white-space: pre-line" [innerHTML]="'auth_enable_anonymous' | translate"></span>
                          </button>
                      </div>
					}


                    <div class="_bottom-actions">
                        <button type="button" mat-button class="_cancel" (click)="cancel()">{{'Cancel' | translate}}</button>
                        <button type="submit" mat-flat-button color="accent" class="rounded">{{'continue' | translate}}</button>
                    </div>
                </form>
            </mat-tab>
            <!--CHALLENGE END-->
			<!--START ANONYMOUS LOGIN -->
			<!--END ANONYMOUS LOGIN -->
        </mat-tab-group>
    </div>
</span>
